import {
  Button,
  Input,
  NumberInput,
  NumberInputField,
  Select,
  Td,
  Text,
  Tooltip,
  Tr
} from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ClientClassificationType } from "models/client_classification_type";
import { CompraSericoTypeItem } from "models/compras_type";
import { ProdutoItemType } from "models/product_item_type";
import { ProductType } from "models/product_type";
import { OptionType } from "models/select_mode";
import { useEffect, useState } from "react";
import formatNumber from "views/admin/order/hooks/formatNumber";

interface IItemRowServico {
  item1: CompraSericoTypeItem;

  editItem: (data: CompraSericoTypeItem) => void;
  deleteRow1: (value: CompraSericoTypeItem) => void;
  produtos: ProductType[];
  unidades: ClientClassificationType[];
}

const ItemRowServico = ({
  deleteRow1,
  editItem,
  item1,
  produtos,
  unidades,
}: IItemRowServico) => {
  const [produtoTexto, setProdutoTexto] = useState("");
  const [produto, setProduto] = useState("");
  const [descricao, setDescricao] = useState("");
  const [unidade, setUnidade] = useState("");
  const [unidadeTexto, setUnidadeTexto] = useState("");
  const [quantidade, setQuantidade] = useState("1");
  const [valor, setValor] = useState("");
  const [total, setTotal] = useState(0);
  const [selectedProdutoItens, setSelectedProdutoItens] =
    useState<ProdutoItemType>();

  const [unidadesDisponiveis, setUnidadesDisponiveis] = useState<
    ClientClassificationType[]
  >([]);
  const [unidadePadrao, setUnidadePadrao] =
    useState<ClientClassificationType>();

  const changeProduto = (item: string) => {
    const prdUn = produtos?.find((value) => value.id === item);
    const unDisp: ClientClassificationType[] = [];
    unidades?.forEach((v) => {
      const existe = prdUn?.ProdutoUnidade?.find(
        (un) => un.unidadeMedidaId === v.id
      );
      if (existe) {
        unDisp.push(v);
        if (existe.principal) {
          changeUnidade(existe.unidadeMedidaId);
          const selected = prdUn.ProdutoUnidade.find(
            (prd) => prd?.unidadeMedidaId === existe.unidadeMedidaId
          );
          if (selected) {
            setSelectedProdutoItens(selected);
            const media =
              (Number(selected.valorMin) + Number(selected.valorMax)) / 2;
            setValor(Number(media).toFixed(2));
          }
          setUnidadePadrao({
            id: existe.unidadeMedidaId,
            idEmpresa: prdUn.idEmpresa,
            nome: v.nome,
          });
        }
      }
    });

    setUnidadesDisponiveis(unDisp);
    setProdutoTexto(prdUn.nome);
    setProduto(item);
    item1.produtoId = item;
    editItem(item1);
  };

  const changeDescricao = (item: string) => {
    setDescricao(item);
  };

  const changeUnidade = (item: string) => {
    const un = unidades?.find((val) => val.id === item);
    const prdUn = produtos?.find((value) => value.id === produto);
    const selected = prdUn?.ProdutoUnidade.find(
      (prd) => prd?.unidadeMedidaId === item
    );
    if (selected) {
      item1.unidadeMedidaId = item;
      editItem(item1);
      setSelectedProdutoItens(selected);
      const media = (Number(selected.valorMin) + Number(selected.valorMax)) / 2;
      setValor(Number(media).toFixed(2));
      setUnidade(item);
      setUnidadeTexto(un.nome);
      const valorTotal = media * Number(quantidade);
      setTotal(valorTotal);
    }
  };
  const changeQuantidade = (item: string) => {
    setQuantidade(item);
  };

  const changeValor = (item: string) => {
    setValor(item);
  };

  const calculate = (item: string) => {
    editItem(item1);

    let totalUn = Number(valor);
    const min = Number(selectedProdutoItens?.valorMin);
    const max = Number(selectedProdutoItens?.valorMax);

    if (totalUn < min) {
      totalUn = min;
    }
    if (totalUn > max) {
      totalUn = max;
    }
    let total = totalUn * Number(quantidade);
    setTotal(total);
    changeValor(totalUn.toString());
  };

  useEffect(() => {
    if(item1) {
        const findPrd = produtos.find((a) => a.id === item1?.produtoId);
        setProdutoTexto(findPrd?.nome);
        setProduto(item1.produtoId);
        setDescricao(item1.descricao);
        setUnidade(item1.unidadeMedidaId);
        setUnidadeTexto(item1.unidadeNome);
        setQuantidade(Number(item1.quantidade).toFixed(2));
        setValor(Number(item1.valorUn).toFixed(2));
        setTotal(item1.valorTotal);
        const prdUn = produtos?.find((value) => value.id === item1.produtoId);
        const unDisp: ClientClassificationType[] = [];
        unidades?.forEach((v) => {
          const existe = prdUn?.ProdutoUnidade?.find(
            (un) => un.unidadeMedidaId === v.id
          );
          if (existe) {
            unDisp.push(v);
            if (existe.principal) {
              const selected = prdUn.ProdutoUnidade.find(
                (prd) => prd?.unidadeMedidaId === existe.unidadeMedidaId
              );
              if (selected) {
                setSelectedProdutoItens(selected);
              }
            }
          }
        });
    
        setUnidadesDisponiveis(unDisp);
    }

}, [item1, unidades, produtos]);

  return (
    <Tr>
      <Td>#</Td>
      <Td>
        <AutoComplete<OptionType, false, GroupBase<OptionType>>
          size="md"
          onChange={(e) => changeProduto(e.value)}
          placeholder="Buscar..."
          name={"Produto"}
          options={produtos?.map((item) => {
            return {
              label: item?.nome,
              value: item?.id,
            };
          })}
          value={{
            label: produtoTexto,
            value: produto,
          }}
        />
      </Td>
      <Td>
        <Input
          isRequired={false}
          fontSize="sm"
          value={descricao}
          ms={{ base: "0px", md: "0px" }}
          type="text"
          placeholder="Digite a Descrição"
          fontWeight="500"
          name={`descricao--${descricao}`}
          border={"none"}
          size="md"
          onChange={(e) => changeDescricao(e.target.value)}
          onBlur={(e) => {
            item1.descricao = e.target.value;
            editItem(item1);
          }}
        />
      </Td>
      <Td>
        <Select
          size="md"
          onChange={(e) => changeUnidade(e.target.value)}
          defaultValue={unidade}
          name={`unidade`}
        >
          {unidadesDisponiveis.map((item) => (
            <option value={item?.id}>{item?.nome}</option>
          ))}
        </Select>
      </Td>
      <Td>
        <NumberInput
          precision={2}
          step={1}
          min={1}
          name={`quantidade--${quantidade}`}
          value={quantidade}
          onChange={(e) => changeQuantidade(e)}
          onBlur={(e) => {
            item1.quantidade = Number(e.target.value);
            editItem(item1);
          }}
        >
          <NumberInputField />
        </NumberInput>
      </Td>
      <Td>
        <Tooltip
          label={`O valor deve ser entre ${formatNumber(
            isNaN(Number(selectedProdutoItens?.valorMin))
              ? 0
              : formatNumber(Number(selectedProdutoItens?.valorMin))
          )} e ${formatNumber(
            isNaN(Number(selectedProdutoItens?.valorMax))
              ? 0
              : formatNumber(Number(selectedProdutoItens?.valorMax))
          )}`}
        >
          <NumberInput
            precision={2}
            name={`valor--${valor}`}
            value={valor}
            onChange={(e) => changeValor(e)}
            onBlur={(e) => calculate(e.target.value)}
          >
            <NumberInputField />
          </NumberInput>
        </Tooltip>
      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={14}
          alignSelf={"center"}
          width={150}
        >
          {formatNumber(Number(total))}
        </Text>
      </Td>
      <Td>
        <Button
          onClick={() => deleteRow1(item1)}
          colorScheme="red"
          variant="ghost"
          ml="1"
        >
          Excluir
        </Button>
      </Td>
    </Tr>
  );
};
export default ItemRowServico;
